const MuiUseMediaQuery = {
  defaultProps: {
    noSsr: true,
  },
}

export default MuiUseMediaQuery
